import React, { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { Container } from "react-bootstrap";
import CONSTANTS from "../utils/constants";

import "./cookiesPopup.css";

const CookiesPopup: React.FC = () => {
  const [cookiesPopupVisibility, setCookiesPopupVisibility] = useState<boolean>(false);
  const location = useLocation();
  const { uuid } = useParams();

  useEffect(() => {
    const hasAgreed = sessionStorage.getItem("isCookiesAccepted");
    if (!hasAgreed) {
      setCookiesPopupVisibility(true);
    }
  }, []);

  useEffect(() => {
    if (location.pathname !== `/${uuid}` && location.pathname !== `/${uuid}/`) {
      setCookiesPopupVisibility(false);
      sessionStorage.setItem("isCookiesAccepted", "true");
    }
  }, [location]);

  const handleAgree = () => {
    sessionStorage.setItem("isCookiesAccepted", "true");
    setCookiesPopupVisibility(false);
  }

  return (
    <>
      {cookiesPopupVisibility && (
        <Container className="cookies-container">
          <div className="cookies-popup" data-testid="pm-cookies-popup">
            <span className="volte-medium text-white popup-heading" data-testid="pm-cookies-popup-heading">
              <FormattedMessage 
                id={CONSTANTS.COOKIE.MESSAGE} 
                defaultMessage="We use cookies to ensure our website functions optimally for you. By continuing to use this website, you agree to our privacy policy."
              />
            </span>
            <span className="vertical-separator" data-testid="pm-cookies-popup-separator" />
            <button onClick={handleAgree} className="ok-button d-flex" data-testid="pm-cookies-popup-ok-button">
              <span className="volte-medium text-white ok-heading" data-testid="pm-cookies-popup-ok-heading">
                <FormattedMessage 
                  id={CONSTANTS.COOKIE.AGREE}
                  defaultMessage="Ok"
                />
              </span>
            </button>
          </div>
        </Container>
      )}
    </>
  )
}

export default CookiesPopup;